if (!customElements.get('coco-shuffle')) {
  class CocoShuffle extends HTMLElement {
    constructor() {
      super();
      this.selectedProduct = null;
      this.selectedSize = null;
      this.selectedLength = null;
      this.selectedColor = null;
      this.selectedQty = null;
      this.showStock = this.dataset.showStock === 'true';
      this.stockThreshold = Number(this.dataset.stockThreshold);
      this.prependedMessage = this.dataset.prependedMessage;
      this.appendedMessage = this.dataset.appendedMessage;
    }
    
    connectedCallback() {
      this.products = JSON.parse(this.dataset.productsJson.replace("}]},]", "}]}]")
        .replaceAll('%27', '&apos;')
        .replaceAll('%22', '&quot;')
        );
      this.baseProduct = this.products.find(product => product.tags.find(x => x === 'base_product')) ?? null;
      this.selectedProduct = this.products.find(({ handle }) => window.location.pathname.split('/').pop() === handle);
      const initialProductId = this.querySelector('input[data-product-id]:checked')?.dataset?.productId;
            
      if (this.selectedProduct?.id === this.baseProduct?.id || !this.selectedProduct) {
        this.selectedProduct = this.products.find(x => x.id === initialProductId);
      }

      const initialSizeOption = this.selectedProduct?.options_with_values
        ?.find(({ name }) => name.toLowerCase().includes('size'));
      if (initialSizeOption && initialSizeOption.values.length === 1) {
        this.selectedSize = initialSizeOption.values[0];
      }

      const initialLengthOption = this.selectedProduct?.options_with_values
        ?.find(({ name }) => name.toLowerCase().includes('length'));
      if (initialLengthOption && initialLengthOption.values.length === 1) {
        this.selectedLength = initialLengthOption.values[0];
      }

      const thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
      this.currentVariant = this.selectedProduct.variants.find(({ options }) => options.every((x) => thisOptionSet.find((y) => y === x)));
      if (!this.currentVariant && thisOptionSet.length >= (this.selectedProduct.options_with_values?.length ?? 0)) {
        this.currentVariant = this.selectedProduct.variants.find(({ available }) => available);
        if (!this.currentVariant) {
          this.currentVariant = this.selectedProduct.variants[0];
        }
      }
      
      if (this.selectedProduct.tags.find(x => x === 'multipack')) {
        const qtyTag = this.selectedProduct.tags.find(x => x.includes('quantity:'));
        if (!qtyTag) return;
        this.selectedQty = parseInt(qtyTag.replace('quantity:', ''));
      }
      
      this.handleQtyDisplay();

      this.setImagesToggle();
      this.addDelegatedClickListeners();
      this.addResizeListener();
      this.createCustomEvents();
      document.addEventListener('DOMContentLoaded', () => {
        // any elements that might not exist yet when the ACE gets added to the DOM
        this.imagesWrapper = [...this.querySelectorAll('[data-product-images]')];
        this.displayPrice = [...this.querySelectorAll('[data-display-price]')];
        this.displayOptions = this.querySelector('[data-display-options]');
        this.displayTitle = [...this.querySelectorAll('[data-display-title]')];
        this.displayColor = [...this.querySelectorAll('[data-display-color]')];
        this.displaySku = [...this.querySelectorAll('[data-display-sku]')];
        this.mainSelect = this.querySelector('[data-main-select]');
        this.querySelector('[data-form-fieldset]')?.removeAttribute('disabled', true);
        this.bazaarVoiceReviewFormatter();
        this.enableOrDisableOptionSelects();
        this.swapOutATC();
        this.updateStockAlert();
        this.querySelector('form[action*="/cart/add"]')?.addEventListener('submit', (e) => {
          if (!this.currentVariant) {
            e.preventDefault();
            e.stopPropagation();
            this.classList.add('selection-needed');
          }
        });
      });
      this.trackHistory(this.selectedProduct.handle);
    }

    addResizeListener() {
      window.addEventListener('resize', debounce(() => {
        this.setImagesToggleBtn();
      }), 1000);
    }

    updateStockAlert() {
      if (!this.currentVariant) return;
      const qtySelects = this.querySelectorAll('select[name="quantity"]');
      qtySelects.forEach(qtySelect => {
        [...qtySelect.options].forEach(option => {
          const value = parseInt(option.value, 10);
          option.disabled = value > this.currentVariant.inventory_quantity;
        });
      });
      
      const stock_alert_el = this.querySelector('[data-stock-alert]');
      if (!stock_alert_el) return;

      if (this.stockThreshold > this.currentVariant.inventory_quantity && this.currentVariant.inventory_quantity > 0) {
        const stock_quantity_el = stock_alert_el.querySelector('[data-stock-quantity]');

        stock_alert_el.classList.remove('hidden');
        stock_alert_el.classList.add('flex');
        stock_quantity_el.innerHTML = this.currentVariant.inventory_quantity;
      } else {
        stock_alert_el.classList.remove('flex');
        stock_alert_el.classList.add('hidden');
      }
    }

    addDelegatedClickListeners() {
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        const currentUrl = new URL(window.location.href); 
        let variantUrl;
        const params = new URLSearchParams(currentUrl.search);
        if (!clickedElement) return;
        
        const {
          action,
          productId,
          option,
          optionType,
        } = clickedElement.dataset;
                  
        switch (action) {
          case 'qty-select':
            if (clickedElement.value === "Single") {
              this.selectedQty = null;
            } else this.selectedQty = parseInt(clickedElement.value);
          case 'product-select':
            if (productId === this.selectedProduct?.id) return;
            
            if (this.selectedQty) {
              const qtyMatch = this.products.find(({ id, tags }) => {
                return id === productId && tags.find(x => x.includes('quantity:'))?.replace('quantity:', '') === this.selectedQty;
              });
              if (qtyMatch) {
                this.selectedProduct = qtyMatch;
              } else this.selectedProduct = this.products.find(({ id }) => id === productId);
            } else this.selectedProduct = this.products.find(({ id, tags }) => id === productId);
            
            if (this.selectedSize && this.selectedLength) {
              this.currentVariant = this.selectedProduct.variants
                .find(({ options }) => (options.find((x) => x === this.selectedSize) && options.find((x) => x === this.selectedLength)))
            } else if (this.selectedSize) {
              this.currentVariant = this.selectedProduct.variants
                .find(({ options }) => options.find((x) => x === this.selectedSize));
            } else {
              const sizeOption = this.selectedProduct.options_with_values
                .find(({ name }) => name.toLowerCase().includes('size'));
              if (sizeOption && sizeOption.values.length === 1) {
                this.selectedSize = sizeOption.values[0];
                this.currentVariant = this.selectedProduct.variants
                  .find(({ options }) => options.find((x) => x === this.selectedSize));
              } else {
                this.currentVariant = null;
              }
            }
            if (!this.currentVariant && (this.selectedSize || this.selectedLength)) {
              this.currentVariant = this.selectedProduct.variants.find(({ available }) => available);
              if (!this.currentVariant) {
                this.currentVariant = this.selectedProduct.variants[0];
              }
            }
            
            let embroiderySection = this.querySelector('[data-section-id="embroidery"]');  
            if (embroiderySection) {
              const drawerModal = document.querySelector('drawer-modal');
              if (drawerModal) {
                drawerModal.activeId = null;
                drawerModal.replaceChildren();
              }
              embroiderySection.innerHTML = `
                <intersection-loader
                  data-url="/products/${this.selectedProduct.handle}"
                  data-section-id="embroidery"
                  class="h-11 w-full block mb-5"
                >
                  <div class="bg-secondaryLight rounded-lg h-11 w-full"></div>
                </intersection-loader>
              `;
            }
            
            const titleArray = this.selectedProduct.title.split('-');
            const productColor = titleArray.pop().replaceAll('&apos;', `'`).replaceAll('&quot;', `"`);
            const newSwatch = this.querySelector(`img[alt="${productColor}"]`);
            const newSwatchSrc = newSwatch?.src;
            const stickySwatch = document.querySelector("[data-sticky-atc-swatch] img");
            if (newSwatchSrc && stickySwatch) stickySwatch.src = newSwatchSrc;
            const stickyImage = document.querySelector("[data-sticky-atc-image] img");
            if (stickyImage && this.currentVariant?.image) stickyImage.src = this.currentVariant.image.src;
            this.displayTitle.forEach(title => title.innerHTML = titleArray.join('-'));
            this.displayColor.forEach(color => color.classList.add('hidden'));
            this.displayColor.forEach(color => color.innerHTML = productColor);
            this.querySelector(`[data-action="product-select"][data-product-id="${this.selectedProduct.id}"]`)
              .closest('[data-color-group]')?.querySelector('[data-display-color]')?.classList.remove('hidden');
            
            this.populateSelectedProductImages();
            this.setImagesToggle();
            this.populateSelectedProductPrice();
            this.populateSelectedProductOptions();
            this.enableOrDisableOptionSelects();
            this.swapOutATC();

            [...document.querySelectorAll('[data-show]')].forEach((el) => {
              if (el.dataset.show === this.selectedProduct.id) {
                el.style.display = null;
                if (el.closest('swiper-carousel')) {
                  el.closest('swiper-carousel').swiper.update();
                }
                return;
              }
              el.style.display = 'none';
            });
            variantUrl = new URL(this.selectedProduct.url, window.location.origin);
            variantUrl.searchParams.forEach((value, key) => params.set(key, value));
            variantUrl.search = params.toString();
            history.replaceState(this.selectedProduct.title, '', variantUrl);
            
            this.mainSelect.innerHTML = `${this.selectedProduct.variants.map((variant) => `
              <option
                value="${variant.id}"
                ${variant.id === this.currentVariant?.id ? 'selected="selected"' : ''}
              >
                ${variant.title} - ${variant.price_money}
              </option>
            `).join('')}`;

            this.handleQtyDisplay();

            if (!this.currentVariant) return;

            this.updateStockAlert();

            this.displaySku.forEach(sku => sku.innerHTML = this.currentVariant.sku.split('|')[0]);
          break;

          case 'option-choice':
            if (!option) {
              console.error('Input with [data-action="option-choice"] is missing a [data-option="value"] attr');
              return;
            }

            const optionIndex = this.selectedProduct.options_with_values
              .findIndex(({ values }) => values
                  .find(x => x === option));
            let thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
            thisOptionSet[optionIndex] = option;
                                    
            const allSelected = this.selectedProduct.options_with_values.every(({ name }) =>
              this.querySelector(`[data-option-type="${name}"]:checked`)
            );
            if (allSelected) this.classList.remove('selection-needed');
            if (optionType.toLowerCase().trim() === 'size') {
              this.selectedSize = option;
            }
            if (optionType.toLowerCase().trim() === 'length') {
              this.selectedLength = option;
              const inseamLabel = this.querySelector('[data-inseam-label]');
              if (inseamLabel) inseamLabel.innerHTML = this.getInseamLabel(option);
            }
            this.currentVariant = this.selectedProduct.variants
            .find(({ options }) => options.every((x) => thisOptionSet.find((y) => y?.toLowerCase().trim() === x?.toLowerCase().trim())));
            
            this.populateSelectedProductPrice();
            this.enableOrDisableOptionSelects();
            this.swapOutATC();
            window.dispatchEvent(this.variantUpdatedEvent);

            if (!this.currentVariant) return;
            const stickySize = document.querySelector("[data-sticky-atc-size]");
            if (stickySize) stickySize.innerText = this.currentVariant.title;
            this.displaySku.forEach(sku => sku.innerHTML = this.currentVariant.sku.split('|')[0]);
            this.mainSelect.value = this.currentVariant.id;

            this.updateStockAlert();
            
            variantUrl = new URL(this.selectedProduct.url, window.location.origin);
            variantUrl.searchParams.forEach((value, key) => params.set(key, value));
            variantUrl.search = params.toString();
            history.replaceState(this.selectedProduct.title, '', variantUrl);
            
            this.imagesWrapper.forEach(wrapper => {
              const variantImage = [...wrapper.querySelectorAll('[data-variants]')].find(({ dataset: { variants } }) => {
                return variants.includes(this.currentVariant.id);
              })
              if (variantImage) {
                wrapper.insertBefore(variantImage, wrapper.firstChild);
              }
            });    
          break;
          case 'notify':
            let drawer = document.querySelector('drawer-modal');
            setTimeout(() => {
              let list = drawer.querySelector('#klaviyo-bis-variant-'+this.selectedProduct.id);
              list.value = this.currentVariant.id
            }, 200);
          break;
          case 'track-alt-click': //Temp experiment tracking
            gtag('event', 'click_alternative_products', {
              event_category: 'experiments',
              event_action: 'altProductFinder',
              value: 1
            });
          break;
          case 'images-toggle':
            const productImagesDesktop = this.querySelector('[data-product-images-desktop]');
            const mediaWrappers = productImagesDesktop.querySelectorAll('[data-media-wrapper]');
            const rotatedEl = this.querySelector('[data-rotate-active]');
            const imagesToggleText = this.querySelector('[data-images-toggle-text]');
            const mediaTileHeight = productImagesDesktop.querySelector('[data-media-wrapper]').offsetHeight;
            let rotation = 0;

            mediaWrappers.forEach( function(wrapper, index) {
              if (index > 3) {
                if (productImagesDesktop.classList.contains('active')) {
                  wrapper.classList.remove('visible');
                  wrapper.classList.add('invisible');
                } else {
                  wrapper.classList.remove('invisible');
                  wrapper.classList.add('visible');
                }
              }
            });

            if (productImagesDesktop.classList.contains('active')) {
              productImagesDesktop.classList.remove('active');
              this.setImagesWrapperHeight(productImagesDesktop, mediaTileHeight);
              if (imagesToggleText) {
                imagesToggleText.innerText = 'show more';
              }
              window.scrollTo({
                top: 0,
                behavior: "smooth"
              });
            } else {
              productImagesDesktop.classList.add('active');
              productImagesDesktop.style.maxHeight = '100%';
              rotation = 180;
              if (imagesToggleText) {
                imagesToggleText.innerText = 'show less';
              }
            }

            if (!rotatedEl) return;
            rotatedEl.style.transform = `rotate(${rotation}deg)`;
          break;
          default: break;
        }
      })
    }
    
    bazaarVoiceReviewFormatter() {
      // this silly app injects everything with inline !important styles that we can't override with css
      // their api is difficult to use and would require a custom app
      // so this mutation observer strips the inline styles from the wrapping element and all children
      // and injects a style tag with highly targeted selectors to override all the !important styles
      // coming in from the external bv stylesheet.
      const reviewElement = this.querySelector('[data-bv-show][data-theme-style-override]');
      const mainReviewSection = document.querySelector('[data-bv-show="reviews"]');
      if (mainReviewSection) mainReviewSection.classList.add('page-width');
      
      if (!reviewElement) return;
      
      if (mainReviewSection) {
        reviewElement.addEventListener('click', () => {
          mainReviewSection.scrollIntoView({ behavior: 'smooth' });
        });
      }
      
      // create and inject our custom styles here
      const bazaarVoiceStyles = document.createElement('style');
      bazaarVoiceStyles.innerHTML = `
        [data-bv-show][data-theme-style-override] {
          cursor: pointer;
        }
        [data-bv-show][data-theme-style-override] .bv_main_container {
          align-items: flex-end !important;
          flex-direction: column-reverse !important;
        }
        [data-bv-show][data-theme-style-override] .bv_main_container .bv_main_container_row_flex {
          outline: none;
        }
        [data-bv-show][data-theme-style-override] .bv_main_container .bv_stars_component_container {
          padding-right: 10px !important;
        }
        [data-bv-show][data-theme-style-override] .bv_main_container .bv_avgRating_component_container,
        [data-bv-show][data-theme-style-override] .bv_main_container .bv_numReviews_text {
          color: #000 !important;
          font-family: 'HelveticaNeue' !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          opacity: 60% !important;
        }
        div.bv_modal_component_container[data-bv-modal] .bv_modal_outer_content{
          border: 1px solid #000 !important;
          border-radius: 8px;
          padding: 1rem !important;
        }
        div.bv_modal_component_container[data-bv-modal] .bv_modal_outer_content:before {
          border-right: 1px solid #000 !important;
          border-bottom: 1px solid #000 !important;
        }
        div.bv_modal_component_container[data-bv-modal] .bv_modal_outer_content .bv_button_component_container button {
          background: #000 !important;
          border-radius: 8px !important;
          color: #fff !important;
          display: block;
          font-family: Poppins, sans-serif !important;
          font-size: 14px!important;
          margin-top: 1rem;
          transition: all 200ms;
          width: 100%;
        }
        div.bv_modal_component_container[data-bv-modal] {
          transform: translateX(-33%);
        }
        div.bv_modal_component_container[data-bv-modal] .bv_modal_outer_content .bv_button_component_container button:hover {
          background: #ffe900 !important;
          color: #000 !important;
        }
        #bv_review_maincontainer h3 {
          line-height: 1 !important;
        }
      `;
      reviewElement.parentNode.append(bazaarVoiceStyles);
      
      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };

      // Callback function to execute when mutations are observed
      const callback = (mutationList) => {
        for (const mutation of mutationList) {
         if (mutation.type === 'childList') {
            // transform the byline text to match the design
            const bvText = reviewElement?.querySelector('.bv_numReviews_component_container .bv_text');
            if (bvText) {
              if (bvText.innerText.includes(')') || bvText.innerText.includes('(')) {
                bvText.innerText = bvText.innerText.replace('(', '').replace(')', '');
                bvText.innerText += ` Review${bvText.innerText == 1 ? '' : 's'}`;
              }
            }
            
            // remove inline styles
            reviewElement.querySelectorAll("*:not(svg)")?.forEach(el => el.removeAttribute('style'));

            // update svg sizes & colors
            reviewElement.querySelectorAll("svg")?.forEach(svg => {
              svg.setAttribute('height', '16px');
              svg.setAttribute('width', '16px');
              svg.style.height = '16px';
              svg.style.width = '16px';
              // filled star color
              svg.querySelector('defs stop[offset="0%"]').style.stopColor = '#000000';
              // empty star color
              svg.querySelector('defs stop[offset="1%"]').style.stopColor = '#D9D9D9';
            });
          }
        }
      };

      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback.bind(this));

      // Start observing the target node for configured mutations
      observer.observe(reviewElement, config);
    }
    
    createCustomEvents() {
      this.addToCartEvent = new CustomEvent('coco-shuffle:add-to-cart', {});
      this.productUpdatedEvent = new CustomEvent('coco-shuffle:product-updated', {});
      this.variantUpdatedEvent = new CustomEvent('coco-shuffle:variant-updated', {});
    }
    
    handleQtyDisplay() {    
      const productElements = this.querySelectorAll('[data-quantity][data-product-id][data-action="product-select"]');
      productElements.forEach(el => el.removeAttribute('checked'));
    
      const normalizeColor = tag => tag.replace(/^color:/i, '').trim();
      const selectedColors = this.selectedProduct.tags
        .filter(tag => /^color:/i.test(tag))
        .map(normalizeColor);
    
      const hasMatchingColor = product =>
        product.tags.some(tag => {
          if (!/^color:/i.test(tag)) return false;
          return selectedColors.includes(normalizeColor(tag));
        });
    
      const seenQuantities = new Set();
      const quantitiesForThisColor = this.products.filter(product => {
        if (!hasMatchingColor(product) || !product.tags.includes('multipack')) return false;
    
        const quantityTag = product.tags.find(tag => /^quantity:/i.test(tag));
        if (!quantityTag || seenQuantities.has(quantityTag)) return false;
    
        seenQuantities.add(quantityTag);
        return true;
      });
    
      productElements.forEach(el => {
        const qtyRaw = el.dataset.quantity || '';
        const qtyClean = qtyRaw.replace(/^quantity:/i, '').trim().toLowerCase();
        const li = el.closest('li');
      
        let shouldShow = false;
      
        if (this.selectedQty === null || this.selectedQty === 'single') {
          shouldShow = qtyClean === 'single';
        } else {
          const selectedQtyClean = typeof this.selectedQty === 'number'
            ? this.selectedQty
            : parseInt(this.selectedQty);
      
          const qtyValue = parseInt(qtyClean);
      
          shouldShow = qtyValue === selectedQtyClean;
        }
      
        li.style.display = shouldShow ? null : 'none';
      
        if (el.dataset.productId === this.selectedProduct.id) {
          el.click();
        }
      });      
    
      const qtyToggleElement = this.querySelector('[data-qty-toggle]');
      qtyToggleElement.innerHTML = '';
    
      const singleProduct = this.products.find(product =>
        hasMatchingColor(product) && !product.tags.includes('multipack')
      );
    
      if (quantitiesForThisColor.length > 0) {
        const buildRadio = (product, label, isChecked) => `
          <div data-toggle-item class="flex relative">
            <input 
              type="radio" 
              id="qty-${product.id}" 
              class="hidden peer" 
              name="Quantity" 
              value="${label}" 
              data-action="qty-select" 
              data-product-id="${product.id}"
              ${isChecked ? 'checked' : ''}
            >
            <label 
              for="qty-${product.id}" 
              class="text-emperor peer-checked:[&_.icon]:scale-100 peer-checked:[&_.icon]:opacity-100 peer-checked:text-primaryDark transition duration-200 th-radio-switch-label inline-flex gap-2 justify-center items-center rounded-full cursor-pointer border-primaryDark pt-1 w-max"
            >
              <span class="block origin-center h-2 w-2 scale-0 opacity-0 rounded-full bg-primaryDark transition-all duration-200 icon"></span>
              <span class="font-semibold">${label}</span>
            </label>
          </div>
        `;
    
        qtyToggleElement.innerHTML = `
          <fieldset-toggle class="th-radio-switch-div px-0 py-4 md:pb-6 flex gap-4 flex-wrap order-first">
            <fieldset data-option-selector data-bundle-selector class="th-radio-switch-container relative w-max">
              <div aria-hidden="true" class="selection-bubble transition-all duration-300 border border-primaryDark bg-white absolute h-9 rounded-full top-px bottom-1 left-2"></div>
              <legend class="sr-only">Quantity</legend>
    
              ${singleProduct ? buildRadio(singleProduct, 'Single', singleProduct.id === this.selectedProduct?.id || !this.selectedQty) : ''}
    
              ${quantitiesForThisColor.map(product => {
                const qtyLabel = product.tags.find(tag => /^quantity:/i.test(tag))?.replace('quantity:', '') || 'Multipack';
                const isChecked = product.id === this.selectedProduct?.id;
                return buildRadio(product, qtyLabel, isChecked);
              }).join('')}
            </fieldset>
          </fieldset-toggle>
        `;
        
        setTimeout(() => {
          const checkedRadio = qtyToggleElement.querySelector('input[type="radio"][checked]');
          if (checkedRadio) checkedRadio.click();
        }, 10);
      }
    }
    
    enableOrDisableOptionSelects() {
      if (!this.selectedProduct || !Array.isArray(this.selectedProduct.variants)) return;

      const normalize = (s) => (s ?? '').toString().toLowerCase().trim();

      const selectedByIndex = [];
      const checkedInputs = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')];
      checkedInputs.forEach(({ value }) => {
        const index = this.selectedProduct.options_with_values?.findIndex(({ values }) => values?.some((v) => normalize(v) === normalize(value))) ?? -1;
        if (index > -1) selectedByIndex[index] = value;
      });

      const availableOptionSets = this.selectedProduct.variants.filter((v) => v?.available).map((v) => v.options || []);

      const optionSelects = [...this.querySelectorAll('[data-option]')];
      optionSelects.forEach((select) => {
        const optionValue = select.dataset.option;
        const optionIndex = this.selectedProduct.options_with_values?.findIndex(({ values }) => values?.some((v) => normalize(v) === normalize(optionValue))) ?? -1;

        const candidate = [...selectedByIndex];
        if (optionIndex > -1) candidate[optionIndex] = optionValue;

        const required = candidate.filter(Boolean); 
        const isAvailable = availableOptionSets.some((set) =>
          required.every((sel) => set.some((opt) => normalize(opt) === normalize(sel)))
        );

        const group = select.closest('.group');
        if (group) group.classList.toggle('unavailable', !isAvailable);
      });

      const required = selectedByIndex.filter(Boolean);
      const colorGroups = [...this.querySelectorAll('[data-color-group]')];

      if (required.length === 0) {
        colorGroups.forEach((group) => {
          group.querySelectorAll('[data-action="product-select"][data-product-id]')
            .forEach((input) => {
              input.closest('li')?.classList.remove('oos');
              input.setAttribute('aria-disabled', 'false');
            });
        });
        return;
      }

      colorGroups.forEach((group) => {
        const swatchInputs = [...group.querySelectorAll('[data-action="product-select"][data-product-id]')];

        swatchInputs.forEach((input) => {
          const li = input.closest('li');
          if (!li) return;

          const productId = String(input.dataset.productId || '');
          const product = this.products?.find((product) => String(product.id) === productId);

          if (!product || !Array.isArray(product.variants)) {
            li.classList.remove('oos');
            input.setAttribute('aria-disabled', 'false');
            return;
          }

          const hasMatch = product.variants.some((variant) =>
            variant?.available && required.every((sel) =>
              (variant.options || []).some((opt) => normalize(opt) === normalize(sel))
            )
          );

          li.classList.toggle('oos', !hasMatch);
          input.setAttribute('aria-disabled', (!hasMatch).toString());
        });
      });
    }
    
    populateSelectedProductImages() {
      const template = this.dataset.template;
      const swiperImages = this.querySelector('[data-images-loader]')
      const loader = this.querySelector(`template[data-images-template]`)?.cloneNode(true);
      const sectionInnerHTML = swiperImages.innerHTML;
      swiperImages.innerHTML = `
        <intersection-loader 
          data-url="/products/${this.selectedProduct.handle}"
          data-section-id="product-images-alt-layout"
        >${loader ? loader.innerHTML : sectionInnerHTML}</intersection-loader>
      `;
    }

    setImagesToggle() {
      const productImagesDesktop = this.querySelector('[data-product-images-desktop]');
      if (!productImagesDesktop) return;
      const mediaTileHeight = productImagesDesktop.querySelector('[data-media-wrapper]').offsetHeight;
      const imagesToggleText = this.querySelector('[data-images-toggle-text]');
      const rotatedEl = this.querySelector('[data-rotate-active]');

      productImagesDesktop.classList.remove('active');
      this.setImagesWrapperHeight(productImagesDesktop, mediaTileHeight);
      if (imagesToggleText) {
        imagesToggleText.innerText = 'show more';
      }
      if (rotatedEl) {
        rotatedEl.style.transform = `rotate(0deg)`;
      }
    }

    setImagesToggleBtn() {
      const productImagesDesktop = this.querySelector('[data-product-images-desktop]');
      if (!productImagesDesktop) return;
      const mediaTilesCount = productImagesDesktop.querySelectorAll('[data-media-wrapper]').length;
      const mediaTileHeight = productImagesDesktop.querySelector('[data-media-wrapper]').offsetHeight;

      if (productImagesDesktop.classList.contains('active')) {
        if (window.innerWidth < 1024) {
          productImagesDesktop.style.maxHeight = `${(mediaTileHeight * mediaTilesCount) + (8 * (mediaTilesCount - 1))}px`;
        } else {
          productImagesDesktop.style.maxHeight = `${mediaTileHeight * (mediaTilesCount / 2) + (8 * mediaTilesCount / 2)}px`;
        }
      } else {
        this.setImagesWrapperHeight(productImagesDesktop, mediaTileHeight);
      }
    }

    setImagesWrapperHeight(imagesDesktopWrapper, mediaTileHeight) {
      if (window.innerWidth < 1024) {
        imagesDesktopWrapper.style.maxHeight = `${mediaTileHeight * 4 + 8 * 3}px`;
      } else {
        imagesDesktopWrapper.style.maxHeight = `${mediaTileHeight * 2 + 8}px`;
      }
    }
    
    populateSelectedProductPrice() {
      const displayVariant = this.currentVariant
        ?? this.selectedProduct?.variants?.find(({ available }) => available)
        ?? this.selectedProduct?.variants?.[0];
      if (!displayVariant || !this.displayPrice) return;
      let stickyATCPrice = document.querySelector("[data-sticky-atc-price]");
      
      stickyATCPrice.innerHTML = displayVariant?.compare_at_price > displayVariant?.price
      ? `
        <span class="text-xs md:text-sm font-medium line-through opacity-60">${String(displayVariant?.compare_at_price_money ?? '').replace(/\.00$/, '')}</span>
        <span class="text-xs md:text-sm font-medium text-white">${String(displayVariant?.price_money ?? '').replace(/\.00$/, '')}</span>`
      :
        `<span class="text-xs md:text-sm font-medium text-white">${String(displayVariant?.price_money ?? '').replace(/\.00$/, '')}</span>`;

      const shopPay = this.querySelector('shopify-payment-terms')?.shadowRoot.querySelector('#shopify-installments')?.querySelector('#shopify-installments-content');
      setTimeout(() => {
        if(((displayVariant?.price / 100).toFixed(2)) > 50 && shopPay != undefined) {
          let splitPrice = ((displayVariant?.price / 100) / 4)
          shopPay.innerHTML = `
            Pay in 4 interest-free installments of <b>$${ (Math.round(splitPrice * 100) /100).toFixed(2) }</b> <div class="mobile-injected">with 
            <div class="inline-flex align-middle text-purple-primary"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99 25" class="text-inherit h-[14px] w-[59px]"><path fill="currentColor" d="M70.842 7.915h2.25c1.561 0 2.328.642 2.328 1.715 0 1.074-.739 1.715-2.259 1.715h-2.32v-3.43ZM80.525 16.142c-.879 0-1.227-.474-1.227-.948 0-.642.725-.935 2.147-1.102l1.115-.125c-.07 1.227-.892 2.175-2.035 2.175Z"></path><path fill="currentColor" fill-rule="evenodd" d="M65.645.5a3.64 3.64 0 0 0-3.64 3.64V20.7a3.64 3.64 0 0 0 3.64 3.64h29.668a3.64 3.64 0 0 0 3.64-3.64V4.14A3.64 3.64 0 0 0 95.314.5H65.645Zm5.197 16.674v-4.197h2.64c2.412 0 3.695-1.353 3.695-3.402 0-2.05-1.283-3.277-3.695-3.277h-4.341v10.876h1.7Zm9.334.223c1.297 0 2.147-.572 2.538-1.548.112 1.088.767 1.645 2.189 1.269l.014-1.157c-.572.055-.683-.154-.683-.753v-2.845c0-1.673-1.102-2.663-3.138-2.663-2.008 0-3.165 1.004-3.165 2.705h1.562c0-.809.572-1.297 1.576-1.297 1.06 0 1.547.46 1.534 1.255v.363l-1.8.195c-2.021.223-3.137.99-3.137 2.329 0 1.101.781 2.147 2.51 2.147Zm9.906.32c-.711 1.73-1.855 2.245-3.64 2.245h-.766V18.54h.822c.977 0 1.45-.307 1.966-1.185L85.3 9.923h1.757l2.259 5.424 2.008-5.424h1.715l-2.956 7.795Z" clip-rule="evenodd"></path><path fill="currentColor" d="M6.992 11.055c-2.359-.509-3.41-.708-3.41-1.612 0-.85.711-1.274 2.134-1.274 1.25 0 2.165.544 2.839 1.61.05.081.155.11.241.066l2.655-1.335a.186.186 0 0 0 .076-.259c-1.102-1.9-3.137-2.94-5.818-2.94C2.188 5.311 0 7.037 0 9.781c0 2.915 2.664 3.651 5.027 4.16 2.362.51 3.417.709 3.417 1.613s-.769 1.33-2.303 1.33c-1.416 0-2.467-.644-3.102-1.896a.186.186 0 0 0-.251-.082L.14 16.21a.188.188 0 0 0-.083.253c1.051 2.102 3.207 3.285 6.087 3.285 3.668 0 5.885-1.698 5.885-4.527 0-2.83-2.677-3.651-5.037-4.16v-.007ZM21.218 5.311c-1.505 0-2.835.531-3.791 1.477-.06.057-.159.015-.159-.067V.687A.185.185 0 0 0 17.081.5h-3.322a.185.185 0 0 0-.187.187v18.73c0 .104.083.186.187.186h3.322a.185.185 0 0 0 .187-.186V11.2c0-1.587 1.223-2.804 2.87-2.804 1.649 0 2.843 1.191 2.843 2.804v8.216c0 .104.082.186.187.186h3.322a.185.185 0 0 0 .187-.186V11.2c0-3.452-2.274-5.89-5.459-5.89ZM33.415 4.774c-1.803 0-3.493.55-4.706 1.343a.186.186 0 0 0-.06.25l1.464 2.488c.054.089.168.12.257.066a5.853 5.853 0 0 1 3.052-.834c2.899 0 5.03 2.036 5.03 4.726 0 2.292-1.706 3.99-3.868 3.99-1.762 0-2.985-1.022-2.985-2.463 0-.825.352-1.502 1.27-1.98a.183.183 0 0 0 .073-.258l-1.381-2.327a.187.187 0 0 0-.226-.079c-1.85.683-3.15 2.327-3.15 4.533 0 3.338 2.67 5.83 6.396 5.83 4.35 0 7.478-3 7.478-7.303 0-4.612-3.64-7.982-8.644-7.982ZM51.776 5.283c-1.68 0-3.182.62-4.277 1.707a.093.093 0 0 1-.16-.066v-1.31a.185.185 0 0 0-.187-.186h-3.235a.185.185 0 0 0-.188.187v18.702c0 .104.083.186.188.186h3.32a.185.185 0 0 0 .188-.186v-6.133c0-.082.099-.123.16-.07 1.091 1.012 2.536 1.603 4.19 1.603 3.897 0 6.936-3.139 6.936-7.217 0-4.078-3.042-7.217-6.935-7.217Zm-.63 11.266c-2.215 0-3.895-1.754-3.895-4.074S48.928 8.4 51.147 8.4c2.22 0 3.893 1.726 3.893 4.075 0 2.348-1.651 4.074-3.896 4.074h.003Z"></path></svg></div>
            </div>
            <style>
              .mobile-injected {
                display: inline;
              }
            </style>
          `
        }
      },0);

      const price = displayVariant?.price_money.endsWith('.00') ? displayVariant.price_money.slice(0, -3) : displayVariant.price_money;
      const compare_price = displayVariant?.compare_at_price_money.endsWith('.00') ? displayVariant.compare_at_price_money.slice(0, -3) : displayVariant.compare_at_price_money;
      let discount_percent = '';

      if (displayVariant.compare_at_price > displayVariant.price) {
        discount_percent = ((displayVariant.compare_at_price - displayVariant.price) * 100) / displayVariant.compare_at_price;
        discount_percent = Math.round(discount_percent);
      }

      this.displayPrice.forEach(el => {
        if (el.dataset.displayPrice === 'simple') {
          el.innerHTML = price;
          return;
        }

        el.innerHTML = displayVariant?.compare_at_price > displayVariant?.price
          ? `
            <span class="font-medium line-through opacity-60 ${el.dataset.mobileProductContent ? `text-base` : `text-lg`}">${compare_price}</span>
            <span class="font-medium text-crimsonRed -order-1 ${el.dataset.mobileProductContent ? `text-base` : `text-lg`}">${price}</span>
            <div data-percent-off-badge class="w-max p-1.5 bg-badgeYellow text-xs font-semibold tracking-[0.2px] rounded-[4px]">${discount_percent}% Off</div>
            `
          :
            `<span class="font-medium text-primaryDark ${el.dataset.mobileProductContent ? `text-base` : `text-lg`}">${price}</span>`;
      });
    } 
    
    populateSelectedProductOptions() {
      if (!this.displayOptions || !this.selectedProduct) return;
      
      const lengthOption = this.selectedProduct.options_with_values.find(({ name }) => name.toLowerCase().includes('length'));
      if (lengthOption && lengthOption.values.length === 1) {
        this.selectedLength = lengthOption.values[0];
      }

      const optionsHTMLString = this.selectedProduct.options_with_values.map(({ name, values }) => {
        if (values.length < 1) return;
        return `
          <div>
            <div class="flex items-center justify-between gap-4 pb-3.5">
              ${name.toLowerCase().includes('size') ? `  
                <div class="flex-1">
                  <strong class="text-xs uppercase">Size:</strong>
                  <span class="text-xs">
                    ${this.selectedProduct.tags.find(x => x.includes('fit:'))?.replace('fit:', '').concat(' fit') || name}
                  </span> 
                </div>
                <div class="predict-placement"
                  data-predict-product-key="${this.selectedProduct.handle}"
                  data-predict-product-name="${JSON.stringify(this.selectedProduct.title)}"
                  data-predict-product-img="${this.selectedProduct.featured_image}">
                </div>
                <button data-drawer-action="open" data-drawer-id="sizeguide" type="button" class="button-link font-normal text-primaryDark text-xs ml-auto">Size Chart</button>` 
              : `
                <span><strong class="text-xs uppercase">${name}</strong>${name.toLowerCase().includes('length') ? `<span class="text-xs" data-inseam-label>${this.getInseamLabel(this.selectedLength)}</span>` : ''}</span>
              `}
            </div>
            <div class="flex flex-wrap items-center gap-2">
              <ul class="inline-flex flex-wrap gap-1">
                ${values.map((value) => {
                  const available = this.selectedProduct.variants.find(({ available, options }) => available && options.find((x) => x == value));
                  let checkedValue;
                  if (values.length === 1) {
                    checkedValue = true;
                  } else if (this.selectedSize) {
                    checkedValue = (this.selectedSize === value);
                  }
                  if (this.selectedLength && !checkedValue) {
                    checkedValue = (this.selectedLength === value);
                  }
                  if (!checkedValue) {
                    checkedValue = this.currentVariant?.options.find((x) => x === value)
                  }
                  return `
                    <li>
                      <div class="${available ? '' : 'unavailable'} group [&.unavailable]:overflow-hidden rounded-[30px] flex items-center gap-2 justify-center relative flex-shrink">
                        <input 
                          data-action="option-choice"
                          data-option="${value}"
                          data-option-type="${name}"
                          id="${this.selectedProduct.id}-${value}" 
                          type="radio"
                          class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer opacity-0 peer" 
                          value="${value}"
                          name="${name}"
                          ${checkedValue ? 'checked' : ''}
                        >
                        <span 
                          class="
                            border 
                            duration-200 
                            flex 
                            items-center 
                            justify-center 
                            py-2
                            pl-2
                            pr-4
                            rounded-[30px] 
                            text-primaryDark 
                            border-secondaryDark
                            group-[.unavailable]:bg-secondaryLight
                            group-[.unavailable]:border-secondaryDark
                            transition-all
                            z-1 
                            peer-hover:text-primaryDark 
                            peer-checked:text-primaryDark
                            peer-checked:[&_.icon]:scale-100
                            peer-checked:[&_.icon]:opacity-100
                            peer-checked:gap-2
                            peer-checked:border-current
                            peer-checked:bg-primaryLight
                            peer-checked:px-4
                          "
                        >        
                          <span aria-hidden="true" class="block h-2 w-2 scale-0 opacity-0 rounded-full bg-primaryDark transition-all duration-200 icon"></span>
                          <span class="block font-semibold">${value}</span>
                        </span>                      
                        <div data-oos class="hidden group-[.unavailable]:block absolute pointer-events-none rotate-[135deg] w-full h-[1px] bg-gray-400 opacity-80"></div>
                      </div>
                    </li>
                `
                }).join('')}
              </ul>
              </div>
              <div data-selection-error class="hidden text-red-500 text-sm mt-2">Please select a ${name.toLowerCase()}.</div>
          </div>`
      }).join('') + ` 
          ${this.showStock && this.currentVariant ? `
          <div data-stock-alert class="hidden justify-center gap-1.5 -mt-3 max-md:-mb-2">
            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_5_83)">
                <path d="M8.76724 19.3145L10.6574 21.4641H12.5926L14.5428 20.7408L15.0828 19.3145L14.8548 18.8708L10.7354 18.574L9.28029 18.8708L8.76724 19.3145Z" fill="#FFE900"/>
                <path d="M12.0706 22C10.2974 22 8.77924 20.7753 8.45521 19.1185H3.40272C2.40663 19.1185 1.59655 18.3405 1.59655 17.3839C1.59655 16.7471 1.95058 16.1074 2.45463 15.8307C3.99078 14.9951 4.86986 13.612 4.86986 12.0301V9.00455C4.86986 6.05105 6.91006 3.58163 9.96435 2.80652C10.1774 1.87292 11.0385 1.18713 12.0375 1.18713C13.0366 1.18713 13.9007 1.85852 14.1137 2.80652C17.168 3.58163 19.2082 6.05105 19.2082 9.00455V12.0013C19.2082 13.6034 20.1053 15.047 21.5515 15.7674C22.0435 16.0036 22.4335 16.6145 22.5386 17.3205V17.3378V17.3839C22.5386 18.3405 21.7285 19.1185 20.7324 19.1185H15.6829C15.3589 20.7753 13.8407 22 12.0676 22H12.0706ZM9.59531 19.1214C9.88034 20.1674 10.8944 20.9223 12.0676 20.9223C13.2407 20.9223 14.2578 20.1645 14.5398 19.1214H9.59231H9.59531ZM12.0375 2.26768C11.4855 2.26768 11.0535 2.68261 11.0535 3.2128V3.66808L10.6154 3.77469C7.80414 4.33081 5.99197 6.38242 5.99197 9.00455V12.0301C5.99197 14.0241 4.90587 15.7558 3.01269 16.7874C2.87167 16.8566 2.71866 17.1274 2.71866 17.3867C2.71866 17.7469 3.02469 18.0408 3.39972 18.0408H20.7354C20.9214 18.0408 21.0984 17.9659 21.2244 17.8363C21.3384 17.721 21.3954 17.5769 21.3864 17.43C21.3594 17.0842 21.1824 16.8076 21.0234 16.7413C19.2022 15.8538 18.0801 14.0385 18.0801 12.0013V9.00455C18.0801 6.38242 16.271 4.33081 13.4687 3.77757L13.0186 3.66808V3.2128C13.0186 2.68261 12.5866 2.26768 12.0345 2.26768H12.0375Z" fill="black"/>
                <path d="M21.4314 15.9893C19.9163 15.2343 18.9472 13.7187 18.9472 12.0013V9.0046C18.9472 6.09432 16.916 3.70846 13.8857 3.00827C13.7657 2.13518 13.0066 1.43787 12.0375 1.43787C11.0685 1.43787 10.3094 2.13806 10.1894 3.00827C7.15908 3.70846 5.12789 6.09432 5.12789 9.0046V12.0301C5.12789 13.7187 4.1888 15.1738 2.58365 16.0469C2.16061 16.2803 1.85458 16.8335 1.85458 17.3839C1.85458 18.1994 2.55064 18.8679 3.39972 18.8679H8.67123C8.88425 20.4988 10.3064 21.7493 12.0646 21.7493C13.8227 21.7493 15.2449 20.4988 15.4579 18.8679H20.7294C21.5785 18.8679 22.2745 18.1994 22.2745 17.3839V17.3551C22.1845 16.7442 21.8485 16.191 21.4254 15.9893H21.4314ZM12.0676 21.1702C10.6424 21.1702 9.4603 20.1818 9.28029 18.8707H14.8578C14.6748 20.1818 13.4927 21.1702 12.0706 21.1702H12.0676ZM20.7354 18.2887H3.39972C2.88367 18.2887 2.46063 17.8824 2.46063 17.3868C2.46063 17.0669 2.64365 16.6866 2.88367 16.5713C4.70185 15.583 5.73395 13.9521 5.73395 12.0301V9.0046C5.73395 6.26721 7.61213 4.11475 10.5524 3.53269L10.7954 3.47506V3.21285C10.7954 2.54435 11.3415 2.01992 12.0375 2.01992C12.7336 2.01992 13.2797 2.54435 13.2797 3.21285V3.47506L13.5227 3.53269C16.463 4.11475 18.3412 6.27009 18.3412 9.0046V12.0013C18.3412 13.9521 19.4033 15.6694 21.1284 16.5137C21.4014 16.629 21.6145 17.0093 21.6445 17.4156C21.6745 17.8824 21.2484 18.2887 20.7324 18.2887H20.7354Z" fill="black"/>
                <path d="M3.33972 9.13713C3.0757 9.13713 2.83868 8.90662 2.83868 8.65593C2.83868 5.74277 3.97879 3.61913 6.32201 2.1611C6.40002 2.10635 6.50503 2.07178 6.61304 2.07178C6.78105 2.07178 6.93407 2.15822 7.01808 2.29653C7.09908 2.41179 7.12909 2.54722 7.09608 2.67689C7.06608 2.80367 6.97607 2.91317 6.85306 2.9708C4.83687 4.2444 3.84377 6.10871 3.84377 8.65593C3.84377 8.9095 3.60375 9.13713 3.34272 9.13713H3.33972Z" fill="black"/>
                <path d="M3.0967 8.65591C3.0967 8.77117 3.21671 8.88931 3.33972 8.88931C3.46273 8.88931 3.58274 8.77405 3.58274 8.65591C3.58274 6.00784 4.61184 4.0859 6.73304 2.7489C6.85306 2.69127 6.88306 2.54432 6.79305 2.42906C6.73304 2.3138 6.58003 2.28499 6.46002 2.37143C4.2158 3.76606 3.0937 5.83495 3.0937 8.65879L3.0967 8.65591Z" fill="black"/>
                <path d="M0.882485 9.16595L0.852482 9.1573C0.62146 9.09967 0.444443 8.88356 0.444443 8.65304C0.723469 4.98494 2.17261 2.19568 4.87587 0.106614C4.93887 0.0461035 5.05288 0 5.1759 0C5.31391 0 5.45192 0.0576293 5.55393 0.155599C5.73695 0.331369 5.72495 0.633923 5.52393 0.826981C3.00669 2.75468 1.68056 5.33359 1.44654 8.73084C1.44654 8.95848 1.21852 9.16595 0.945491 9.16595H0.882485Z" fill="black"/>
                <path d="M5.34091 0.651218C5.43092 0.564774 5.46092 0.417819 5.37092 0.331375C5.28091 0.244931 5.12789 0.216117 5.03788 0.302561C2.40063 2.33976 0.975495 5.07427 0.702469 8.65593C0.702469 8.77119 0.792477 8.88933 0.915489 8.91815H0.945492C1.0655 8.91815 1.18852 8.8317 1.18852 8.71356C1.42854 5.22123 2.79367 2.60197 5.34091 0.651218Z" fill="black"/>
                <path d="M20.7654 9.13711C20.5014 9.13711 20.2643 8.90659 20.2643 8.65591C20.2643 6.10869 19.2712 4.24438 17.231 2.95637C17.003 2.795 16.931 2.5155 17.051 2.28786C17.15 2.13803 17.3061 2.06311 17.4801 2.06311C17.5671 2.06311 17.6541 2.08328 17.7321 2.12074C20.1203 3.61622 21.2694 5.75139 21.2694 8.65879C21.2694 8.91236 21.0294 9.13999 20.7684 9.13999L20.7654 9.13711Z" fill="black"/>
                <path d="M20.5224 8.65585C20.5224 8.77111 20.6424 8.88925 20.7654 8.88925C20.8884 8.88925 21.0084 8.77399 21.0084 8.65585C21.0084 5.83201 19.8863 3.766 17.6151 2.33967C17.4951 2.28205 17.3421 2.31086 17.2821 2.3973C17.222 2.51256 17.2521 2.65952 17.3721 2.74596C19.4933 4.08296 20.5224 6.0049 20.5224 8.65297V8.65585Z" fill="black"/>
                <path d="M23.1626 9.10824C22.8896 9.10824 22.6616 8.90078 22.6616 8.65585C22.4245 5.31623 21.0984 2.75461 18.6052 0.847077C18.4822 0.731819 18.4222 0.599271 18.4222 0.466724C18.4222 0.348584 18.4672 0.239088 18.5542 0.158407C18.6562 0.060437 18.7942 0.00280762 18.9322 0.00280762C19.0552 0.00280762 19.1692 0.0489111 19.2532 0.129592C21.9295 2.1956 23.3786 4.96181 23.6637 8.56941C23.6847 8.70196 23.6487 8.83739 23.5587 8.94112C23.4686 9.04773 23.3306 9.11112 23.1926 9.11112H23.1626V9.10824Z" fill="black"/>
                <path d="M19.0672 0.302561C18.9772 0.216117 18.8242 0.244931 18.7342 0.331375C18.6442 0.417819 18.6742 0.564774 18.7642 0.651218C21.3084 2.60197 22.6736 5.22122 22.9166 8.65593C22.9166 8.77119 23.0366 8.86052 23.1596 8.86052H23.1896C23.3096 8.86052 23.4326 8.74526 23.4026 8.5983C23.1296 5.07715 21.7045 2.33976 19.0672 0.305442V0.302561Z" fill="black"/>
              </g>
              <defs>
                <clipPath id="clip0_5_83">
                  <rect width="23.2222" height="22" fill="white" transform="translate(0.444443)"/>
                </clipPath>
              </defs>
            </svg>
            <div class="text-sm md:text-base text-electricTrees font-medium">${this.prependedMessage} <span data-stock-quantity class="text-black">${this.currentVariant.inventory_quantity}</span> ${this.appendedMessage}</div>
          </div>
        ` 
        : `` }
      `
      this.displayOptions.innerHTML = optionsHTMLString;
    }

    getInseamLabel(selectedLength) {
      const inseams = this.selectedProduct?.inseams?.length
        ? this.selectedProduct.inseams
        : (this.baseProduct?.inseams || []);
      if (!selectedLength || !inseams.length) return '';
      const match = inseams.find(item => item.split('::')[0].toLowerCase().trim() === selectedLength.toLowerCase().trim());
      if (!match) return '';
      const message = match.split('::')[1];
      return message ? `: ${message}` : '';
    }

    swapOutATC() {
      const atcButton = this.querySelector('[data-action="add-to-cart"]'),
            oosButton = this.querySelector('[data-out-of-stock]'),
            bisButtons = this.querySelectorAll('[data-notify-me]'),
            stickyATC = document.querySelector('[data-atc-scroll-desktop]'),
            altFinder = this.querySelectorAll('[data-alt-finder]');

      const checkedOptions = this.querySelectorAll('[data-action="option-choice"]:checked');
      const totalOptionTypes = this.selectedProduct?.options_with_values?.length ?? 0;
      const allOptionsSelected = checkedOptions.length >= totalOptionTypes;

      if (!allOptionsSelected) {
        stickyATC?.removeAttribute('data-atc-ready');
        stickyATC?.removeAttribute('data-atc-notify');
        atcButton.removeAttribute('disabled');
        return;
      }

      if (!this.currentVariant) {
        stickyATC?.removeAttribute('data-atc-ready');
        stickyATC?.removeAttribute('data-atc-notify');
        atcButton.setAttribute('disabled', true);
        if (!oosButton) return;
        bisButtons.forEach(button => button.classList.remove('peer-disabled:block'));
        oosButton.classList.add('peer-disabled:block');
        oosButton.innerHTML = "Unavailable";
        return;
      }

      atcButton.innerHTML = 'Add To Bag';
      this.currentVariant.available ? atcButton.removeAttribute('disabled') : atcButton.setAttribute('disabled', true);
      this.currentVariant.available ? altFinder.forEach(button => button.classList.add('hidden')) : altFinder.forEach(button => button.classList.remove('hidden'));
      oosButton.innerHTML = "Unavailable";

      const hideBis = !!this.selectedProduct.tags.find(x => x === 'hide_bis');
      if (hideBis) {
        oosButton?.classList.add('peer-disabled:block');
        bisButtons.forEach(button => button.classList.remove('peer-disabled:block'));
      } else {
        oosButton?.classList.remove('peer-disabled:block');
        bisButtons.forEach(button => button.classList.add('peer-disabled:block'));
      }

      if (this.currentVariant.available) {
        stickyATC.setAttribute('data-atc-ready', '');
        stickyATC.removeAttribute('data-atc-notify');
        stickyATC.innerHTML = "Add To Bag";
      } else if (hideBis) {
        stickyATC.removeAttribute('data-atc-ready');
        stickyATC.removeAttribute('data-atc-notify');
        stickyATC.innerHTML = "Unavailable";
      } else {
        stickyATC.removeAttribute('data-atc-ready');
        stickyATC.setAttribute('data-atc-notify', '');
        stickyATC.innerHTML = "Notify Me";
      }

      const productColor = this.selectedProduct.title.split('-').pop();
      const newSwatch = this.querySelector(`img[alt="${productColor}"]`);
      const stickySwatch = document.querySelector('[data-sticky-atc-swatch] img');
      if (newSwatch && stickySwatch) stickySwatch.src = newSwatch.src;
    }

    trackHistory(initialProductId) {
      const maxHistoryLength = 10;
      const history = JSON.parse(localStorage.getItem('viewhHistory') || '[]');
      if (!history.includes(initialProductId) ) {
        const isHistoryMaxed = history.length === maxHistoryLength;
        const workingHistory = isHistoryMaxed ? history.slice(1) : history;
        const updatedHistory = workingHistory.concat(initialProductId);
      
        localStorage.setItem('viewhHistory', JSON.stringify(updatedHistory));
      }
    }
  }
    
  customElements.define('coco-shuffle', CocoShuffle);
}